"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gtmDataHandler = void 0;
exports.gtmInit = gtmInit;
var _domReadyPromise = require("../../deprecated/domReadyPromise");
var _logger = require("../../logger");
var _events = require("../events");
var _ContextEventData = require("../events/ContextEventData");
var _events2 = require("./events");
const logger = _logger.mainLogger.createChild('gtm');
const GOOGLE_TAG_MANAGER_PATH = '//www.googletagmanager.com/gtm.js?id=';
let model;
function createDataLayer() {
  if (typeof window.dataLayer === 'undefined') {
    window.dataLayer = [];
  }
  if (typeof window.gtag === 'undefined') {
    window.gtag = (...params) => window.dataLayer?.push(...params);
  }
}
function pushToDataLayer(data) {
  logger.info(`Pushing message to dataLayer: ${data.event}`, data);
  if (!window.dataLayer) {
    throw new Error(`GTM's dataLayer is not initialized, ${data.event} will be lost.`);
  }
  window.dataLayer.push(data);
}
function createGoogleTagManagerScript() {
  const script = document.createElement('script');
  script.async = true;
  script.src = GOOGLE_TAG_MANAGER_PATH + model.GtmId;
  document.head.insertAdjacentElement('afterbegin', script);
}

/** Standard GTM initialization event. */
function pushGtmStartEvent() {
  const data = {
    event: _events2.GTM_START_EVENT,
    [_events2.GTM_START]: Date.now()
  };
  pushToDataLayer(data);
}

/**
 * Records basic user and other context data information.
 *
 * This is being called only in Online where the server-side serialized
 * configuration contains the needed data.
 *
 * In ASMS, the context-data custom event will be called instead on client
 * with a slightly different timing, containing the same data.
 */
function pushContextDataEvent() {
  // Exit in ASMS page case where the data is not available from server.
  if (typeof model.CustomerId !== 'number') {
    return;
  }
  // TO-DO: workaround until the serialization on server is updated
  const customerId = model.CustomerId === 0 ? -1 : model.CustomerId;
  const data = {
    consultantId: model.ConsultantId ?? 0,
    customerId,
    customerTypeId: model.CustomerTypeId ?? 0,
    event: _ContextEventData.CONTEXT_DATA_EVENT,
    periodId: Number(model.PeriodId)
  };
  pushToDataLayer(data);
}

/**
 * Records info about a successfully finished user registration process.
 * This works in Online based on session object logic in BE code.
 * TO-DO: The Online session object should be avoided & common solution
 * for Online & ASMS pages should be implemented later.
 */
function pushRegisteredUserEvent() {
  const data = {
    customerTypeId: model.RegisteredCustomerTypeId ?? 0,
    event: _events.REGISTERED_USER_EVENT,
    registeredUserId: model.RegisteredConsultantNumber ?? '',
    registrationChannel: model.RegistrationChannel ?? '',
    registrationType: model.RegistrationType ?? '',
    sponsorNumber: model.SponsorNumber ?? '',
    signUpDate: model.RegistrationSingUpDate ?? '',
    visitorSegment: model.RegistrationVisitorSegment ?? 0
  };
  pushToDataLayer(data);
}

/**
 * Records info about a successfully finished user login process.
 * This works in Online based on session object logic in BE code.
 * TO-DO: The Online session object should be avoided & common solution
 * for Online & ASMS pages should be implemented later.
 */
function pushLoginEvent() {
  const data = {
    consultantId: model.ConsultantId ?? 0,
    event: _events.LOGIN_EVENT,
    loginType: model.LoginType ?? null
  };
  pushToDataLayer(data);
}

/**
 * Records info about a successfully finished user upgrade process.
 * This works in Online based on session object logic in BE code.
 * TO-DO: The Online session object should be avoided & common solution
 * for Online & ASMS pages should be implemented later.
 */
function pushCustomerUpgradedEvent() {
  const data = {
    customerNewType: model.CustomerTypeIdAfterUpgrade ?? null,
    customerOldType: model.CustomerTypeIdBeforeUpgrade ?? null,
    event: _events.UPGRADED_USER_EVENT,
    upgradedUserId: model.ConsultantId ?? 0
  };
  pushToDataLayer(data);
}

/** Optionally records particular user state changes if the needed data is available. */
function pushUserStateChangedEvents() {
  // TODO: Handle this differently. It looks like userUpgraded event is not pushed at all, based on info in https://oriflamecosmetics-my.sharepoint.com/:x:/g/personal/abdulss_oriflame_com/ESpUal8comFPqQfg2c1WeEcBlQ9bldInwCknI_euikJhzg?wdOrigin=TEAMS-MAGLEV.p2p_ns.rwc&wdExp=TEAMS-TREATMENT&wdhostclicktime=1760512639354&web=1.
  // TODO: https://oriflame.visualstudio.com/Developer-Experience-Improvements/_git/OnlineMarketPreparation?path=/Website.Mvc/Ori.Online.Website.Impl/Components/Analytics/AnalyticsUiService.cs&version=GBmain&_a=contents&line=245&lineStyle=plain&lineEnd=245&lineStartColumn=25&lineEndColumn=36

  if (model.IsLoggedInEvent) {
    void (0, _domReadyPromise.domReadyPromise)().then(pushLoginEvent, undefined);
  }
  if (model.IsCustomerRegistrationEvent) {
    void (0, _domReadyPromise.domReadyPromise)().then(pushRegisteredUserEvent, undefined);
  }
  if (model.IsCustomerUpgradeEvent) {
    void (0, _domReadyPromise.domReadyPromise)().then(pushCustomerUpgradedEvent, undefined);
  }
}

/** Implementation of event forwarding into GTM. */
const gtmDataHandler = (event, message) => {
  const data = {
    event,
    ...message
  };
  pushToDataLayer(data);
};

/** Initialization of GTM analytics channel. */
exports.gtmDataHandler = gtmDataHandler;
function gtmInit(data) {
  model = data;
  createDataLayer();
  createGoogleTagManagerScript();
  pushGtmStartEvent();
  pushContextDataEvent();
  pushUserStateChangedEvents();
  return gtmDataHandler;
}